(function () {
  function initRoot(root) {
    if (!root || root.dataset.guidesListMounted === 'true') return;
    root.dataset.guidesListMounted = 'true';

    var mqMobile = window.matchMedia('(max-width: 767px)');

    root.querySelectorAll('.guides-list__cell').forEach(function (cell) {
      var dialog = cell.querySelector('dialog.guides-list__modal');
      var hit = cell.querySelector('.guides-list__card-hit');
      var closeBtn = cell.querySelector('[data-guides-modal-close]');

      if (!dialog) return;

      function openModal(e) {
        if (!mqMobile.matches) return;
        if (e) e.preventDefault();
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      }

      function closeModal() {
        if (typeof dialog.close === 'function') {
          dialog.close();
        }
      }

      if (hit) {
        hit.addEventListener('click', openModal);
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          closeModal();
        });
      }

      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) closeModal();
      });

      dialog.addEventListener('cancel', function (e) {
        e.preventDefault();
        closeModal();
      });
    });
  }

  function mountAll() {
    document.querySelectorAll('[data-guides-list-root]').forEach(initRoot);
  }

  function teardown(root) {
    if (!root) return;
    delete root.dataset.guidesListMounted;
  }

  function domReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  domReady(mountAll);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-guides-list-root]');
    if (root) {
      delete root.dataset.guidesListMounted;
      initRoot(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-guides-list-root]');
    teardown(root);
  });
})();
